
/**
 * Formats a date string or Date object to "DD MMM YYYY, hh:mm AM/PM"
 * Example: "24 Mar 2026, 02:05 PM"
 */
export const formatReportDate = (dateInfo: string | Date | undefined | null): string => {
  if (!dateInfo) return '—';
  
  const date = new Date(dateInfo);
  if (isNaN(date.getTime())) return '—';

  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();
  
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const strHours = hours.toString().padStart(2, '0');

  return `${day} ${month} ${year}, ${strHours}:${minutes} ${ampm}`;
};
